export default function ({stroke = "white"}) {return(
	<svg stroke={stroke} xmlns="http://www.w3.org/2000/svg" width="42" height="20">
		<rect x="1" y="1" width="32" height="18" rx="2" ry="2" fill="transparent" strokeWidth="1"></rect>
		<line x1="7" y1="1" x2="17" y2="10" strokeWidth="1"></line>
		<line x1="27" y1="1" x2="17" y2="10" strokeWidth="1"></line>
	</svg>
)
}